import { render } from "./index.vue?vue&type=template&id=f4a696bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f4a696bc&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/akc-mallrobot-akc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a696bc"]])

export default __exports__